<template lang="pug">
	.online-users-header(v-if="Layout.isFeatureEnabled('online-users')" :class="{admin: User.currentUser.Tags['admin']}")
		.online-users-list
			.user-groups(v-for="group in groups")
				.user-group
					transition(name="user-fade" appear v-for="userData in group.users")
						.user-content
							.user-icon-area
								.user-photo(:style="{backgroundImage: `url(${(User.Users[userData.userId] || userData)['photo'] || 'Images/Screens/Login/default-user-icon.jpg'})`}")
									.c-avatar-status.bg-success
								.groups-connector
							.user-hover-wrapper(:class="`user-${userData.userId}`")
								.arrow-top
								.connections(v-if="getUserDataFlag(userData)")
									.connection-flag(:style="{background: `url(/Images/Icons/Flags/${getUserDataFlag(userData)}.svg) center / contain no-repeat`}" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: User.COUNTRIES[getUserDataFlag(userData)] || ''}")
								.user-hover-content
									.top-info
										.avatar-holder
											.avatar(:style="{backgroundImage: `url(${userData['photo'] || 'Images/Screens/Login/default-user-icon.jpg'})`}")
											.avatar-separator
										.info-holder
											.info-header.text-center
												.publisher-logo(:style="{background: `url(${getUserPublisherImage(userData)}) left center / contain no-repeat`}" @click="choosePublisher(userData.publisherId)")
											.user-name(@click="chooseUser(userData.userId)")
												.name {{(User.Users[userData.userId] || userData)['name']}}
									.project-and-version-info
										.project-info
											.field-title Looking project:
											.field-value(@click="openProject(userData)") {{getUserDataProjectTitle(userData)}}
										.version-info
											.field-title Looking version:
											.field-value(@click="openVersion(userData)") {{getUserDataVersionTitle(userData)}}
									//.actions-info
										.action-group(v-for="(actionsGroup, groupDate) in userData.actionsGrouped")
											.action-group-caption {{actionsGroup.title}}
											.action-group-items
												.action-info(v-for="action in actionsGroup.actions")
													.date(:title="action[0].toLocaleString()") {{action[0].toLocaleTimeString()}}
													.type {{action[1]}}
													.title {{action[2]}}
													.description {{action[3]}}
</template>

<script>

	import Screen 			from './../../mixins/screen'

	import { Publisher } 	from './../../services/Publisher'
	import { User } 		from './../../services/User'

	export default {
		name: "OnlineUsersHeader",
		mixins: [Screen],
		screen: {
			updateOn: ["Publishers Changed", "Current User Feature Changed", "Users Online Status Changed", "User Online Status Changed",
				"User Online Status Added", "User Online Status Removed", "User Changed"]
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			this.groups = [];

			return {
				showed: true
			}
		},
		methods: {
			collectData() {

				//Убираем из групп пользователей которые уже не онлайн
				this.groups = _.map(this.groups, group => {return {publisherId: group.publisherId, users: _.filter(group.users, userData => User.usersOnlineStatus.Users[userData.userId])}});

				//Убираем группы без пользователей
				//Если убирать группы сразу то не будет плавной анимации исчезновения пользователя
				//this.groups = _.filter(this.groups, group => group.users.length > 0);

				_.each(User.usersOnlineStatus.Users, userData => {

					//Ищем среди существующих группу этого пользователя
					let group = _.find(this.groups, group => group.publisherId === userData.publisherId);

					//Если нету - создаём группу
					if (!group) {

						group = {publisherId: userData.publisherId, users: []};

						this.groups.push(group);

					}

					//Ищем в группе пользователя
					let groupUserData = _.find(group.users, groupUserData => groupUserData.userId === userData.userId);

					//Если есть - обновляем, если нету - вставляем
					if (groupUserData) _.extend(groupUserData, userData);
					else {
						group.users.push(userData);
						group.users = _.sortBy(group.users, 'userId');
					}

				});

			},
			getUserPublisherImage(userData) {

				let publisher = Publisher.Publishers[userData.publisherId];

				return publisher ? `/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${publisher['last_activity_time'] || publisher['create_date']}` : ''

			},
			getUserDataProjectTitle(userData) {

				let connection = User.getLastActiveVersionData(userData);

				if (connection) return connection.projectTitle;
				else return '';

			},
			getUserDataVersionTitle(userData) {

				let connection = User.getLastActiveVersionData(userData);

				if (connection) return connection.versionCodename || connection.versionTitle;
				else return '';

			},
			getUserDataFlag(userData) {

				let connection = _.find(userData.connections, connection => connection.country);

				if (connection) return connection.country;
				else return '';

			},
			choosePublisher(publisherId) {

				Publisher.selectPublisher(publisherId);

			},
			chooseUser(userId) {

				Layout.setPage('user-profile', {userId: userId/*, backPage: [Layout.page, Layout.pageOptions]*/});

			},
			openProject(userData) {

				let connection = User.getLastActiveVersionData(userData);

				if (Publisher.SelectedPublisher?.id === connection.publisherId || !User.currentUser.Tags['admin']) {

					Project.selectProject(connection.projectId);

				} else if (User.currentUser.Tags['admin']) {

					window.localStorage.setItem('selected-project-id-for-publisher-' + connection.publisherId, connection.projectId);

					Publisher.selectPublisher(connection.publisherId);

				}

			},
			openVersion(userData) {

				let connection = User.getLastActiveVersionData(userData);

				window.localStorage.setItem("selected-version-for-project-" + connection.projectId, connection.versionId);

				Project.selectProject(connection.projectId);

			}
		}
	}
</script>

<style lang="sass" scoped>

	.online-users-header
		height: 51px
		overflow: visible
		margin-left: 20px

		.online-users-list
			display: flex
			flex-direction: row

			.user-groups
				display: flex
				flex-direction: row

				.user-group
					display: flex
					flex-direction: row

					.user-content
						width: 40px
						height: 51px
						position: relative

						.user-icon-area
							opacity: 0.7
							transition: opacity 0.5s

							.user-photo
								position: absolute
								background: center / auto 100% no-repeat
								width: 24px
								height: 24px
								border-radius: 24px
								cursor: pointer
								top: 13px
								left: 8px
								z-index: 1

								.c-avatar-status
									width: 8px
									height: 8px
									position: absolute
									bottom: 0
									right: 0
									display: block
									border: 1px solid #fff
									border-radius: 8px

							.groups-connector
								position: absolute
								top: 26px
								right: -10px
								font-size: 0
								height: 1px
								width: 20px
								background-color: rgba(255,255,255,0.1)

						.user-hover-wrapper
							display: none
							flex-direction: row
							align-items: center
							justify-content: center
							position: absolute
							z-index: 10000
							width: 250px
							top: 50px
							left: calc((-250px + 44px) / 2)
							border-radius: 0.25rem
							padding: 0
							border: 1px solid #2f353a
							box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
							background-color: #5f656c
							transition: opacity 1.5s
							cursor: default

							&.user-2
								//display: block

							.arrow-top
								position: absolute
								top: -10px
								left: calc(50% - 15px)
								width: 0
								height: 0
								border-left: 10px solid transparent
								border-right: 10px solid transparent
								border-bottom: 10px solid #5f656c

							.connections
								position: absolute
								right: 0
								top: 0
								display: flex
								flex-direction: row
								justify-content: right
								width: calc(100% - 5px)
								padding: 5px

								.connection-flag
									display: flex
									width: 20px
									height: 15px
									margin: 0 0 0 2px

							.user-hover-content
								display: flex
								flex-direction: column

								.top-info
									display: flex
									flex-direction: row
									height: 48px

									.avatar-holder
										position: relative

										.avatar
											width: 35px
											height: 35px
											background: transparent center / contain no-repeat
											border-radius: 35px
											margin: 7px

										.avatar-separator
											display: block
											position: absolute
											right: -6px
											top: 0
											width: 1px
											height: 30px
											background: rgba(0, 0, 0, 0.2)
											margin: 10px 5px

									.info-holder
										display: flex
										flex-direction: column
										justify-content: flex-start
										padding-left: 10px

										.info-header
											padding-top: 3px
											display: block
											margin-bottom: 0
											font-size: 0.765625rem
											color: #e4e7ea
											white-space: nowrap
											height: 25px

											.publisher-logo
												height: 18px
												width: 100%
												margin-top: 3px
												cursor: pointer

										.user-name
											color: #e4e7ea
											font-weight: 400
											white-space: nowrap
											display: flex
											flex-direction: row
											align-items: center
											justify-content: space-between
											text-align: left
											cursor: pointer

											.name
												font-size: 0.8rem
												width: 180px
												overflow: hidden
												text-overflow: ellipsis

										.user-name:hover
											text-decoration: underline

								.project-and-version-info
									display: flex
									flex-direction: column
									margin: 2px 10px 5px 10px
									border-top: 1px solid rgba(0, 0, 0, 0.2)
									//border-bottom: 1px solid rgba(0, 0, 0, 0.2)
									//padding-bottom: 5px

									.project-info
										display: flex
										flex-direction: row
										margin-top: 5px

									.version-info
										display: flex
										flex-direction: row
										margin-bottom: 3px

									.field-title
										white-space: nowrap
										width: 100px
										color: rgba(243, 244, 245, 0.5)
										font-size: 0.75rem

									.field-value
										width: 150px
										color: #fff
										font-size: 0.75rem
										font-weight: bold
										overflow: hidden
										text-overflow: ellipsis
										white-space: nowrap
										cursor: pointer

										&:hover
											text-decoration: underline

								//.actions-info
									display: flex
									flex-direction: column
									margin: 2px 10px 5px 10px

									.action-group

										.action-group-caption
											font-size: 0.75rem
											color: #fff

										.action-info
											display: flex
											flex-direction: row
											flex-wrap: nowrap
											font-size: 0.75rem
											color: #fff

											.date
												color: rgba(243, 244, 245, 0.5)
												padding-right: 5px
												white-space: nowrap
												width: 50px

											.type

												padding-right: 5px
												white-space: nowrap
												width: 70px
												text-align: center

											.title
												display: none
												padding-right: 5px
												white-space: nowrap
												overflow: hidden
												text-overflow: ellipsis

											.description
												display: none
												white-space: nowrap
												overflow: hidden
												text-overflow: ellipsis
												width: 205px

						&:hover

							.user-hover-wrapper
								display: block

						&.user-fade-enter, &.user-fade-leave-to
							opacity: 0

						&.user-fade-enter-active, &.user-fade-leave-active
							transition: opacity 0.2s

						&:last-child

							.groups-connector
								display: none

</style>

